import React from 'react';
import s from './WarningMessage.module.scss'
import warning from './image/warning.png'
import classNames from 'classnames'

const WarningMessage = ({ error, className }) => {
    return (
        <div className={classNames(s.main, className)}>
            <div className={s.content} >
                <div className={s.imageContainer}>
                    <img src={warning} alt="" />
                </div>
                <div className={s.textContainer} >
                    <p className={s.text}>
                        {error}
                    </p>
                </div>
            </div>
            <div className={s.bubble}>
            </div>
        </div>
    );
};


WarningMessage.defaultProps = {
    error: ''
};

export default WarningMessage;